export const liveIndicSelector = ({liveIndic}) => liveIndic